export default function DataTable({ columns, rows, empty = "Belum ada data.", testid = "data-table" }) {
  return (
    <div className="w-full overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
      <table className="w-full text-sm" data-testid={testid}>
        <thead className="bg-slate-50">
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className="text-left px-3.5 py-2.5 text-[10px] font-bold uppercase tracking-[0.1em] text-slate-600 border-b border-slate-200"
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-3 py-10 text-center text-slate-400 text-sm">
                {empty}
              </td>
            </tr>
          ) : (
            rows.map((r, i) => (
              <tr
                key={r.id || i}
                className="border-b border-slate-100 hover:bg-slate-50/70 transition-colors duration-200"
              >
                {columns.map((c) => (
                  <td key={c.key} className="px-3.5 py-2.5 text-slate-700 text-[13px] align-middle">
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
